import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcText,
  PixelCheckboxGroup,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'
import { createOrderSources, updateOrderSources } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const OrderSourceForm = (props) => {
  const { handleClose, editingSource } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState({
    code: '',
    description: '',
    is_default: 1,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (editingSource) {
      handleUpdateSource()
    } else {
      handleAddStatus()
    }
  }
  const handleUpdateSource = () => {
    showPageLoader()
    updateOrderSources(data).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Updated')
        setData({
          code: res.response.data.code,
          description: res.response.data.description,
          is_default: res.response.data.is_default,
        })
        handleClose(res.response.data, 'update')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  const handleAddStatus = () => {
    showPageLoader()
    createOrderSources(data).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Added')
        setData({
          code: res.response.data.code,
          description: res.response.data.description,
          is_default: res.response.data.is_default,
        })
        handleClose(res.response.data, 'add')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  React.useEffect(() => {
    if (editingSource) {
      setData({
        ...data,
        ...editingSource,
      })
    }
  }, [editingSource])
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Code
            </DcText>
            <DcInput
              error={
                error.field === 'code' && error.error !== ''
                  ? error.error
                  : null
              }
              disabled={!!editingSource}
              required
              type={'text'}
              name={'Code'}
              placeholder={'Code'}
              value={data.code}
              onChange={(e) => setData({ ...data, code: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Description
            </DcText>
            <DcInput
              error={
                error.field === 'description' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              as={'textarea'}
              name={'description'}
              placeholder={'Description'}
              value={data.description}
              onChange={(e) =>
                setData({ ...data, description: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <PixelCheckboxGroup
            label="Is Default"
            options={[
              {
                label: 'Yes',
                value: '1',
                type: 'radio',
                checked: data.is_default == 1,
              },
              {
                label: 'No',
                value: '0',
                type: 'radio',
                checked: data.is_default == 0,
              },
            ]}
            onChange={(e) => {
              setData({ ...data, is_default: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          justifyContent="flex-end"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcButton variant="primary" type="submit" withIcon={true} size="sm">
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default OrderSourceForm
